<!-- guangfu 智能变配电运行总览  -->
<template>
  <div class="OverviewAll" style=" padding: 0 !important;">
    <div class="kanban">
      <div class="tit" style="width: 100%;height: 65px;">
        <img src="@/assets/intelligence/bt.png" style="width: 100%;height: 100%;" />
        <span class="txt">{{title || '智能变配电运行总览'}} </span>
        <div class="my-timer">
          {{ timerYMD }}
          <div class="xingqi">{{ timerWeek }}</div>
          {{ timerHMS }}
        </div>
        <div class="imgs">
          <img src="@/assets/imgs/guan.png" v-if="fullscreen" @click="handleFullScreen" />
          <img src="@/assets/imgs/kai.png" v-else @click="handleFullScreen" />
        </div>
      </div>

      <div class="con_tent">
           <div class="zhuangt" >
            <img src="@/assets/intelligence/bor4.png" alt="">
            <div class="s">
              电站总数：<span>32</span>
            </div>
          </div>
        <!-- 第一行 -->
        <div class="con_box">
          <div class="lefts">
            <div class="li_box" style="height: 46vh;">
              <div class="tits">
                <img src="@/assets/intelligence/biao.png" alt="">
                <span>发电/收益统计</span>
              </div>
              <div class="li_cen li_cen3">
                <div class="cen">
                  <div class="mli">
                    <div class="num"><i>2563.00</i></div>
                    <div class="text">累计发电量(kWh)</div>
                  </div>
                  <div class="mli">
                    <div class="num"><i>1682.00</i></div>
                    <div class="text">累计收益(万元)</div>
                  </div>
                </div>
                <div class="ul_box">
                  <span style="    margin-bottom: 15%;">
                  <div class="imgd">
                    <img class="im" src="@/assets/imgs/g2.png" alt="">
                    <div class="text"><span>268.2</span>MWh</div>
                    <div class="name">今年发电量</div>
                  </div>
                  <div class="ul">
                    <div class="li"><img src="@/assets/intelligence/jian.png">昨日发电量<span>165.2 kWh</span>
                    </div>
                    <div class="li"><img src="@/assets/intelligence/jian.png">本月发电量<span>2659.2 kWh</span>
                    </div>
                  </div>
                </span>
                <span>
                  <div class="imgd">
                    <img class="im" src="@/assets/imgs/g1.png" alt="">
                    <div class="text"><span style="color: #FFD400;">23</span>万元</div>
                    <div class="name">今年总收益</div>
                  </div>
                  <div class="ul">
                    <div class="li"><img src="@/assets/intelligence/jian.png">昨日收益<span>412 元</span>
                    </div>
                    <div class="li"><img src="@/assets/intelligence/jian.png">本月收益<span>2345 元</span>
                    </div>
                  </div>
                </span>
                </div>
              </div>
            </div>
        
          </div>
          <div class="medio">
            <div class="right">
          
              <div class="li_box" style="height: 17vh;">
                <div class="tits">
                  <img src="@/assets/intelligence/biao.png" alt="">
                  <span>社会公益</span>
                </div>
                <div class="li_cen" style="height: 76%;align-items: center;">

                  <div class="ul2" style="margin-top: 0;">
                    <div class="li">
                      <img src="@/assets/imgs/s3.png">
                      <div class="num">1.23</div>
                      <div class="name">CO2减排(吨)</div>
                    </div>
                    <div class="li">
                      <img src="@/assets/imgs/s2.png">
                      <div class="num">2.21</div>
                      <div class="name">节约标准煤(吨)</div>
                    </div>
                    <div class="li">
                      <img src="@/assets/imgs/s1.png">
                      <div class="num">234</div>
                      <div class="name">等效植树量(棵)</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="li_box marginTop" style="height: 29vh;" >
              <div class="tits">
                <img src="@/assets/intelligence/biao.png" alt="">
                <span>电量排行</span>
              </div>
              <div class="ul4" style="height: 25vh;">
                <div class="li2" v-for="(e,i) in zongDian" :key="i">
                  <span class="img" :class="{'img2':i>2}">
                    <div class="num">{{i+1}}</div>
                  </span>
                  <div class="right2">
                    <div class="name">
                      <div class="l">{{e.name}}</div>
                      <div class="r">
                        <div class="n">{{e.value}}</div>kWh
                      </div>
                    </div>
                    <div class="b">
                      <div class="b_l"><span :style="{'width':e.value/zongshu*100+ '%'}"></span></div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            </div> 
          </div>

        </div>
        <div class="con_box">
          <div class="li_box marginTop" :style="heighted">
              <div class="tits tits2">
                <img src="@/assets/intelligence/biao.png" alt="">
                <span>发电量统计</span>
              </div>
              <div class="li_cen li_cen2" >
                 <div class="search">
                  <span style=" margin-right: auto; margin-left: 20px;">kwh</span>
           
                    <div class="radio_b">
                      <span :class="{'active':plantRadio=='day'}" @click="plantRadio='day';dianzhan()">日</span>
                      <span :class="{'active':plantRadio=='month'}" @click="plantRadio='month';dianzhan()">月</span>
                      <span :class="{'active':plantRadio=='year'}" @click="plantRadio='year';dianzhan()">年</span>
                    </div>
                  </div>
                  <span class="aaa"  >
                    <span id="vchart2" class="vcharted"  ></span> 
                  </span>
                 

              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import vchart from "@/components/module/chart/vchart.vue";
 
  import request from "@/api/http.js"; 
 
 
  var vchart2;
  export default {
    components: {
      vchart,
    
    },
    data() {
      return {
        flag:true,
        fadian: {
          "今年发电量": "0.0",
          "昨日发电量": "0.0",
          "较上月": "0",
          "较去年": "0",
          "较前日": "0",
          "本月发电量": "0.0"
        },
        shouyi: {
          "本月收益": "0",
          "累计收益": "0",
          "昨日收益": "0",
          "今年收益": "0"
        },
        coCount: 0,
        coCount2: 0,
        coCount3: 0,
        zongshu: 0,
        zongDian: [
          {
            name:'A光伏电站',
            value:'312',
          },
          {
            name:'B光伏电站',
            value:'212',
          },
          {
            name:'C光伏电站',
            value:'202',
          },
          {
            name:'D光伏电站',
            value:'111',
          },
        ],
        plantRadio: 'day',
        listData: [],
        title: getName(),
       
        co2TranslateRatio: 0.875, //折算系数
        coefficient:0.1226,//转煤
        translateRatio:0.785,//转树
        barOption2: {
          xAxis: [
            {
              type: "category",
              data: [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "10",
                "11",
                "12",
                "13",
                "14",
                "15",
                "16",
                "17",
                "18",
                "19",
                "20",
                "21",
                "22",
                "23",
                "24",
                "25",
                "26",
                "27",
                "28",
                "29",
                "30",
                "31",
              ],
              splitLine: {
                show: false,
                lineStyle: {
                  type: "dashed",
                  color: "#333333",
                },
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: "#999999",
                },
              },
              axisTick: {
                //y轴刻度线
                show: false,
              },
              axisLine: {
                //y轴
                show: false,
              },
            },
          ],
          yAxis: [
            {
             
              type: "value",
              splitLine: {
                lineStyle: {
                  type: "dashed",
                  color: "#333",
                },
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: "#999",
                },
              },
              axisTick: {
                //y轴刻度线
                show: false,
              },
              axisLine: {
                //y轴
                show: false,
              },
            },
          ],
          color: ["#0088FF" ], 
          tooltip: {
            trigger: "axis",
            confine: true,
            axisPointer: {
              animation: false,
            },
          },
          grid: {
            left: "1%",
            right: "20",
            bottom: "6%",
            top: "15%",
            containLabel: true,
          },
          series: [
          {
            name: "电量",
            type: "bar",
            itemStyle: {
              normal: {
                color: {
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  type: "linear",
                  global: false,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#005EFF",
                    },
                    {
                      offset: 1,
                      color: "#005EFF",
                    },
                  ],
                },
              },
            },
            data: [ 
              400,
              540,
              340,
              560,
              340,
              620,
              710,
              310,
              420,
              390,
              460,
              510,
              610,
              720,
              620,
              450,
              510,
              520,
              600,
              640,
              620,
              710,
              310,
              420,
              390,
              460,
              520,
              600,
              640,
              620,
              510,
            ],
          },
          {
            name: "电费",
            type: "bar",
            itemStyle: {
              normal: {
                color: {
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  type: "linear",
                  global: false,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#FF9532",
                    },
                    {
                      offset: 1,
                      color: "#FF9532",
                    },
                  ],
                },
              },
            },
            data: [
            650,
              400,
              440,
              440,
              660,
              440,
              520,
              710,
              310,
              420,
              390,
              460,
              510,
              410,
              520,
              620,
              450,
              410,
              520,
              600,
              640,
              620,
              510,
              310,
              420,
              590,
              460,
              520,
              600,
              640,
              520,
            
            ],
          },
        ],
        }, 
        selectTab: 0, //0今日1昨日2前日
        thisMonthData: [
          //电量
          { value: 0, name: "尖" },
          { value: 0, name: "峰" },
          { value: 0, name: "平" },
          { value: 0, name: "谷" },
        ], //当月数据
        thisMonthData2: [
          //电费
          { value: 0, name: "尖" },
          { value: 0, name: "峰" },
          { value: 0, name: "平" },
          { value: 0, name: "谷" },
        ], //当月数据
        lastMonthData: [
          //电量
          { value: 0, name: "尖" },
          { value: 0, name: "峰" },
          { value: 0, name: "平" },
          { value: 0, name: "谷" },
        ], //本月数据
        lastMonthData2: [
          //电费
          { value: 0, name: "尖" },
          { value: 0, name: "峰" },
          { value: 0, name: "平" },
          { value: 0, name: "谷" },
        ], //本月数据
       
       
        heights: document.getElementById("app").clientHeight - 590, //屏幕高度 - 导航栏高度
        fullscreen: false,
        timerNull: null,
        timerYMD: "",
        timerWeek: "",
        timerHMS: "", 
      

        zongVal: 0, //光伏总发电量

        value1: "",
        plantTime: new Date().getTime(),
        deviceTime: new Date().getTime(),
        plantDateType: "date",
        deviceDateType: "date",
        deviceRadio: "date",
        radio: 1,
        plantRadio: "day", 
     
      
      
        option5: {
          tooltip: {
            trigger: "axis",
            confine: true,
            axisPointer: {
              animation: false,
            },
          },
          color: ["#0088FF"],
          xAxis: {
            type: "category",
            splitLine: {
                show: false,
                lineStyle: {
                  type: "dashed",
                  color: "#333333",
                },
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: "#999999",
                },
              },
              axisTick: {
                //y轴刻度线
                show: false,
              },
              axisLine: {
                //y轴
                show: false,
              },
            data: [],
          },
          yAxis: {
              nameTextStyle: { 
                color:'#fff',
                lineHeight: 5
              },
         
              type: "value",
              splitLine: {
                lineStyle: {
                  type: "dashed",
                  color: "#333",
                },
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: "#999",
                },
              },
              axisTick: {
                //y轴刻度线
                show: false,
              },
              axisLine: {
                //y轴
                show: false,
              },
            },
            grid: {
            left: "1%",
            right: "20",
            bottom: "6%",
            top: "15%",
            containLabel: true,
          },
          series: [
            {
         
              barWidth: 15,  // 设置柱子宽度 
              data: [],
              type: "bar",
            },
          ],
        },
        timerArrMon: [],
        timerArrYear: [
          "1月",
          "2月",
          "3月",
          "4月",
          "5月",
          "6月",
          "7月",
          "8月",
          "9月",
          "10月",
          "11月",
          "12月",
        ],
        option44: {
          tooltip: {
            trigger: "axis",
            confine: true,
            axisPointer: {
              animation: false,
            },
          },
          color: ["#0088FF"],
          xAxis: {
            type: "category",
            splitLine: {
                show: false,
                lineStyle: {
                  type: "dashed",
                  color: "#333333",
                },
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: "#999999",
                },
              },
              axisTick: {
                //y轴刻度线
                show: false,
              },
              axisLine: {
                //y轴
                show: false,
              },
            data: [],
          },
          yAxis: {
              nameTextStyle: { 
                color:'#fff',
                lineHeight: 5
              },
         
              type: "value",
              splitLine: {
                lineStyle: {
                  type: "dashed",
                  color: "#333",
                },
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: "#999",
                },
              },
              axisTick: {
                //y轴刻度线
                show: false,
              },
              axisLine: {
                //y轴
                show: false,
              },
            },
            grid: {
            left: "1%",
            right: "20",
            bottom: "6%",
            top: "15%",
            containLabel: true,
          },
          series: [
            {
        
              barWidth: 15,  // 设置柱子宽度 
              data: [],
              type: "bar",
            },
          ],
        },
        option45: {
          legend: {},
          tooltip: {
            trigger: "axis",
          },
          color: ["#5f96f1"],
          xAxis: {
            type: "category",
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#fff",
                //fontSize:12
              },
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            data: [],
          },
          yAxis: {
            type: "value",
            //设置网格线颜色
            splitLine: {
              show: true,
              lineStyle: {
                color: ["#fff"],
              },
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#fff",
              },
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#fff",
              },
            },
          },
          grid: {
            top: "15%",
            left: "1%",
            bottom: "4%",
            right: "1%",
            containLabel: true,
          },
          series: [
            {
              data: [],
              type: "bar",
            },
          ],
        },
        option4: {
          legend: {
            type: "scroll",
          },
          tooltip: {
            trigger: "axis",
          },
          color: ["#fe9611"],
          xAxis: {
            type: "category",
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#fff",
                //fontSize:12
              },
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            data: [],
          },
          yAxis: {
            type: "value",
            //设置网格线颜色
            splitLine: {
              show: true,
              lineStyle: {
                color: ["#fff"],
              },
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#fff",
              },
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#fff",
              },
            },
          },
          grid: {
            top: "22%",
            left: "1%",
            bottom: "4%",
            right: "1%",
            containLabel: true,
          },
          series: [
            {
              data: [],
              type: "bar",
              barWidth: 15,
            },
          ],
        },
       
      };
    },
    computed: {
      heighteds(){
        if (this.fullscreen) {
          return {height:'44vh'}
        }else{
          return {height:'31vh'}
        } 
      },
      heighted(){
        if (this.fullscreen) {
          return {height:'43vh'}
        }else{
          return {height:'30vh'}
        } 
      },
      heighted2(){
        if (this.fullscreen) {
          return {height:'36vh'}
        }else{
          return {height:'23vh'}
        }
         
      },
      unitId() {
        return this.$store.unitStore.state.nowUnit;
      },
      xList() {
        var list = [];
        for (var h = 0, len = 24; h < len; h++) {
          for (var m = 0, lenm = 60; m < lenm; m += 5) {
            list.push((h < 10 ? "0" : "") + h + ":" + (m < 10 ? "0" : "") + m);
          }
        }
        return list;
      },


    },
    watch: {
      unitId(nv, ov) { 
        this.dianzhan();
        this.getList();
      },
      nowUnit(nv, ov) { 


      },

    },
    mounted() {
 
      var timerArr = [];
      this.timerArrMon = [];
      for (let i = 0; i < 24; i++) {
        timerArr.push(i > 9 ? i + ":00" : "0" + i + ":00");
      }
      this.option44.xAxis.data = timerArr;
      let date = new Date();
      let year = date.getFullYear(); //年
      let month = date.getMonth() + 1; //月

      let days = new Date(year, month, 0).getDate();

      for (let i = 1; i <= days; i++) {
        this.timerArrMon.push(i);
      };
      
      // var params = { typeNo: 36 };
      // // 获取转换系数 
 
      vchart2 = echarts.init(document.getElementById("vchart2"));
      vchart2.setOption(this.barOption2,true); 
 
      this.dianzhan();
      this.getList();

      this.timerNull = setInterval(() => {
        // 获取当前日期
        const date = new Date();

        // 获取年份(4位,如2022)
        const year = date.getFullYear();

        // 获取月份(0-11,所以获取月份要加1)
        const month = date.getMonth() + 1;

        // 获取日期
        const day = date.getDate();

        // 获取周几(0-6,0表示周日)
        const week = date.getDay();

        // 24小时制时间
        const hours = date.getHours();

        // 分钟
        const minutes = date.getMinutes();

        // 秒
        const seconds = date.getSeconds();
        this.timerYMD = year + "年" + month + "月" + day + "日";
        this.timerWeek =
          "星期" + ["日", "一", "二", "三", "四", "五", "六"][week];
        this.timerHMS =
          (hours > 10 ? hours : "0" + hours) +
          ":" +
          (minutes > 10 ? minutes : "0" + minutes) +
          ":" +
          (seconds > 10 ? seconds : "0" + seconds);
      }, 1000);
    },

    methods: {
      getList() {
        // 光伏收益->获取看板填充发电量数据
        var params = {
          code: 0,
          unitId: this.unitId.id,
        }
        request({
          url: "/photovoltaicIncome/getFillData",
          method: "post",
          params,
        }).then((res) => {
          if (res.code == 200) {
            this.fadian = res.data;
          }
        });

        var params = {
          'unitId': this.unitId.id
        }
   
    




        // 收益
        request({
          url: "/photovoltaicIncome/getIncome",
          method: "post",
          params,
        }).then((res) => {
          console.log(res, 111)
          if (res.code == 200) {
            this.shouyi = res.data;
          }
        });




      },
      // 电站发电量
      dianzhan() {
        var dd = {
          code: 0,
          dateType: this.plantRadio,
          startDate: new Date().getTime(),
          unitId: this.unitId.id,
        };
   
    
      }, 

      handleFullScreen() {
      
        // 此处可根据获取节点进行区域全屏事件
        let element = document.getElementsByClassName("kanban")[0];
        if (this.fullscreen) {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          }
        } else {
          if (element.requestFullscreen) {
            element.requestFullscreen();
          } else if (element.webkitRequestFullScreen) {
            element.webkitRequestFullScreen();
          } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
          } else if (element.msRequestFullscreen) {
            // IE11
            element.msRequestFullscreen();
          }
        }
        this.fullscreen = !this.fullscreen;
        this.flag = false;
        setTimeout(() => {
          this.flag = true;
        }, 200);
        setTimeout(() => {
          vchart2.resize(); 
        }, 500);
      },
      bbb() {
        this.$router.push("/usePowerUnit");
      },
    },
    filters: {

      // 转换时间戳
      date_format: function (value) {
        //value就是插值的数据
        if (value == "") {
          return "";
        }
        return value.replace(/-/g, "");
      },
    },
  };
</script>

<style lang="scss" scoped>
.ul_box{
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  >span{
    display: flex;
  }
}
 .radio_b{
    font-family: Microsoft YaHei;
    font-size: 14px;
    font-weight: bold;  
    font-variation-settings: "opsz" auto;
    color: #ccc;
    display: flex;
    margin-right: 10px;
    span{
      margin-right: 12px;
      cursor: pointer;
    }
    .active{
      color: #0062FF;
    }
  }
  .vcharted{
    display: block;
    width: 100%;
    height: 100%; 
  }
  .zhuangt {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 34px;
    .s{
      position: absolute;
    top: 0;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 17px; 
    font-family: Microsoft YaHei;
    span{ 
        font-family: YouSheBiaoTiHei; 
        font-weight: bold;
        line-height: normal;
        text-align: center;
        display: flex;
        align-items: center; 
        font-size: 22px;
        font-variation-settings: "opsz" auto;
        background: linear-gradient(180deg, #f3f8ff 22%, #4d93ff 82%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent;
    }
    }
  }
.aaa{
  flex: 1; 
  display: block;
  width: 100%;
  height: 100%;
}
.marginTop{
  margin-top: 12px;
}
  .search {
    display: flex;
    justify-content: end;
    width: 100%;
    margin-top: 13px;
  }

  .li_cen3 {
    display: flex;
    flex-direction: column;

    .cen {
      display: flex;
      padding: 0 19px;
      justify-content: space-between;
      margin-top: 24px;

      .mli {
        width: calc(50% - 9px);

        .text {
          font-family: Microsoft YaHei;
          font-size: 14px;
          font-weight: bold;
          margin-top: 8px;
          color: #FFF;
          text-align: center;
        }

        .num {
          background: url(../../assets/intelligence/shuzi.png) no-repeat;
          background-size: 100% 100%;
          display: flex;
          justify-content: center;
          height: 40px;

          i {
            height: 40px;
            text-align: center;
            font-family: Arial;
            font-style: italic;
            line-height: 37px;
            font-size: 24px;
            font-weight: bold;
            font-variation-settings: "opsz" auto;
            background: linear-gradient(180deg, #f3f8ff 12%, #0087FF 82%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            text-fill-color: transparent;
          }
        }
      }
    }

    .imgd {
      width: 38%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .text {
        margin-top: 2px;
        margin-bottom: 2px;

        >span {
          font-family: Arial;
          font-size: 20px;
          font-weight: bold;
          color: #25A4FF;
          margin-right: 4px;
        }
      }

      .name {
        font-family: Microsoft YaHei;
        font-size: 13px;
      }
    }

    >span {
      display: flex;
      margin-top: 36px;
    }
  }

  .tul::-webkit-scrollbar {
    display: none;
  }

  .tul {
    padding-right: 12px;
    display: flex;
    flex-direction: column;
    height: 100px;
    overflow-y: scroll;

    .tli {
      display: flex;
      align-items: center;
      font-family: Microsoft YaHei;
      font-size: 13px;
      margin-bottom: 10px;


      .txt {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        flex: 1;
      }

      .n {
        color: #FFB914;
      }

      .baojin {
        color: #ff7300;
      }

      .xiaoxi {
        color: #37ffc9;
      }

      .time {
        font-size: 12px;
        color: #999;
        margin-left: auto;
      }
    }
  }

  #kanban {
    width: 100%;
    position: fixed;
    top: 0;
    margin: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100% !important;
    z-index: 10;
  }

  .con_tent {
    display: flex;
    padding: 20px;
    box-sizing: border-box;
    flex-direction: column;
    width: 100%;
    overflow: hidden;
    padding-top: 32px;

    .con_box {
      display: flex;
      justify-content: space-between;
    }

    .li_box {
      width: 100%;
      color: #fff;
      background: linear-gradient(180deg, rgba(28, 64, 96, 0.1) 0%, rgba(28, 64, 96, 0.4) 100%);
      box-sizing: border-box;
      display: flex;
      flex-direction: column;

      .ul4::-webkit-scrollbar {
        display: none;
      }

      .ul4 {
        display: flex;
        flex-direction: column;
        padding-top: 16px;
        height: 215px;
        overflow-y: scroll;

        .li2:nth-last-child(1) {
          margin-bottom: 0;
        }

        .li2 {
          display: flex;
          align-items: center;
          margin-bottom: 30px;

          .img {
            width: 24px;
            height: 24px;
            position: relative;
            background: url(../../assets/imgs/bor.png) no-repeat;
            background-size: 100% 100%;
            text-align: center;
            line-height: 24px;
            font-family: Microsoft YaHei; 
            font-size: 12px; 
            font-weight: bold;
            color: #D39400;
            box-sizing: border-box;
            margin-left: 14px;
            margin-right: 6px;
          }
          .img2{
            background: url(../../assets/imgs/bor2.png) no-repeat;
            background-size: 100% 100%;
            color: #1383EB;
          }

          .right2 {
            width: calc(100% - 60px);
            display: flex;
            flex-direction: column;
          }

          .name {
            display: flex;
            justify-content: space-between;
            font-family: Microsoft YaHei;
            font-size: 13px;
            font-weight: normal;

            .r {
              display: flex;

              .n {
                font-family: Arial;
                font-size: 16px;
                font-weight: bold;
              }
            }


          }

          .b {
            display: flex;
            margin-top: 4px;

            .b_l {
              display: flex;
              width: 287px;
              height: 4px;
              border-radius: 4px;
              background: rgba(19, 131, 235, 0.2);

              span {
                height: 4px;
                border-radius: 4px;
                background: linear-gradient(90deg, #1383EB 0%, #13D5EB 99%);
              }
            }
          }
        }
      }



      .li_cen2 {
        flex: 1;
        display: flex;flex-direction: column;
        align-items: center;
      }

      .li_cen {
        flex: 1;
        display: flex;

        .ul5 {
          .li {
            margin-top: 34px !important;
          }
        }

        .imd {
          width: 100px;
          height: 100px;
          margin-top: 51px;
          margin-left: 15px;
        }

        .ul2 {
          flex: 1;
          display: flex;
          justify-content: space-around;

          .li {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .name {
              font-family: Microsoft YaHei;
              font-size: 13px;
              font-weight: normal;
            }

            .num {
              font-family: Arial;
              font-size: 20px;
              font-weight: bold;
              margin-top: 2px;
              margin-bottom: 5px;
            }

            img {
              width: 48px;
              height: 48px;
              margin-top: 5px;
            }
          }
        }

        .left {
          display: flex;
          flex-direction: column;
          margin-left: 12px;

          .span2 {
            color: #20c135 !important;
            padding-left: 10px;
          }

          .span3 {
            color: #ff3d27 !important;
            padding-left: 10px;
          }

          .lli {
            display: flex;
            width: 340px;
            height: 45px;
            box-sizing: border-box;
            padding-left: 8px;
            background: rgba(7, 33, 75, 0.6);
            align-items: center;
            margin-top: 12px;

            .n {
              width: 107px;
              text-align: right;
              padding-right: 20px;
              color: #3CA1FF;
            }
          }

          .lli:nth-child(1) {
            margin-top: 0;
          }
        }



        .ul {
          flex: 1;
          padding-right: 16px;
          display: flex;
          flex-direction: column;  

          .li {
            background: url(../../assets/intelligence/lu2.png) no-repeat;
            background-size: 100%;
            background-position: bottom center;
            display: flex; 
            padding-bottom: 5px;
            font-family: Microsoft YaHei;
            font-size: 13px;

            .bian {
              display: flex;
              flex-direction: column;
              width: 100%;
              text-align: center;

              .name {
                font-size: 19px;
                margin-top: 13px;
              }

              span {
                margin: 0;
                font-size: 25px;
              }
            }

            span {
              font-size: 14px;
              font-weight: bold;
              margin-left: auto;
            }
          }
          .li:nth-child(2){
            margin-top: auto;
          }
        }
      }

      .tits {
        height: 28px;
        display: flex;
        align-items: center;
        font-family: Microsoft YaHei;
      
    
        box-sizing: border-box;
        padding-bottom: 7px;
        background: url(../../assets/intelligence/xiao.png) no-repeat;
        background-size: 100% 100%;
        >span{
          font-size: 16px;
          
        }
        img {
          margin-right: 7px;
        }
      }

      .tits2 {

        background: url(../../assets/intelligence/xiaoc.png) no-repeat;
        background-size: 100% 100%;


      }
    }

    .lefts {
      display: inline-block;
      width: 23.54%;
    }

    .medio {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      box-sizing: border-box;
      padding-left: 12px;

      .right {
        display: inline-block;
        width: 31%;

      }
    }


  }

  .kanban {
    width: 100%;
    background: url(../../assets/imgs/bgc.png) no-repeat;
    background-size: 100% 100%;
    filter: brightness(1);
    color: #fff;

    .tit {
      position: relative;

      .imgs {
        position: absolute;
        right: 20px;
        top: 31px;
      }

      .my-timer {
        position: absolute;
        top: 34px;
        left: 20px;
        display: flex;
        align-items: center;
        font-size: 16px;

        .xingqi {
          margin: 0 20px;
        }
      }

      .txt {
        position: absolute;
        left: 50%;
        top: 12%;
        transform: translateX(-50%);
        font-size: 36px;

        font-family: YouSheBiaoTiHei;

        font-weight: bold;
        line-height: normal;
        text-align: center;
        display: flex;
        align-items: center;
        letter-spacing: 3px;
        font-size: 36px;
        font-variation-settings: "opsz" auto;
        background: linear-gradient(180deg, #f3f8ff 22%, #4d93ff 82%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent;
      }
    }
  }

  .OverviewAll {
    background-color: #000;
  }
</style>
<style>
  .OverviewAll .el-progress__text {
    display: none;
  }

  .OverviewAll .el-progress-bar {
    box-sizing: content-box;
  }
</style>